export default __webpack_public_path__ + "locales/pl/ArchiveDialog.json?hash=2dd8bc4be79f4c9535c844ecca6a6963";